var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtmlLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#9ca3af",
    width: "96px",
    height: "96px",
    viewBox: "0 0 3.84 3.84",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.922 2.033 -0.063 0.197h-0.095l0.158 -0.493V0.953h0.881l-0.168 1.847 -0.714 0.192zM1.92 3.84C0.86 3.84 0 2.98 0 1.92S0.86 0 1.92 0s1.92 0.86 1.92 1.92 -0.86 1.92 -1.92 1.92m-0.884 -0.904L1.918 3.18l0.886 -0.244L3 0.78H0.84zm0.62 -0.815 -0.423 -0.172v-0.071l0.423 -0.172v0.089l-0.296 0.119 0.296 0.118zm0.952 -0.172v-0.071l-0.423 -0.172v0.089l0.296 0.118 -0.296 0.118v0.089zm-0.685 0.084 0.132 -0.41h-0.096l-0.036 0.114z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlLogo);
export default __webpack_public_path__ + "static/media/html-logo.eec1ae8551714ae867019c4cc17bf1e4.svg";
export { ForwardRef as ReactComponent };